export const getAzureRoleAssignmentCommand = (
  servicePrincipal: string,
  role: string,
  scope: string,
) => {
  return `az role assignment create --assignee ${servicePrincipal} --role "${role}" --scope "${scope}"`;
};
